import axios from 'axios'

export type FulfillmentRequestFailureKind =
  | 'validation'
  | 'unauthorized'
  | 'forbidden'
  | 'not-found'
  | 'conflict'
  | 'too-many-requests'
  | 'unknown'

const failureKindByStatus: Partial<Record<number, FulfillmentRequestFailureKind>> = {
  400: 'validation',
  401: 'unauthorized',
  403: 'forbidden',
  404: 'not-found',
  409: 'conflict',
  429: 'too-many-requests',
}

/** Определяет вид отказа заявки по коду ответа сервера. */
export const parseFulfillmentRequestFailureKind = (error: unknown): FulfillmentRequestFailureKind => {
  if (!axios.isAxiosError(error)) {
    return 'unknown'
  }

  return failureKindByStatus[error.response?.status ?? 0] ?? 'unknown'
}
